import helpers from '../helpers';

const $tabs = $('.js-tabs');

function init() {
	$tabs.each((i, el) => {
		const $btn = $(el).find('.js-tabs-btn');
		const $tabsButtons = $(el).find('.js-tabs-buttons');
		const $btnActive = $(el).find('.js-tabs-active');
		const $content = $(el).find('.js-tabs-content');

		$btnActive.on('click.tabs', (e) => {
			if (helpers.isMobile()) {
				if ($(e.currentTarget).hasClass('is-active')) {
					$(e.currentTarget).removeClass('is-active');
					$tabsButtons.slideUp();
				} else {
					$(e.currentTarget).addClass('is-active');
					$tabsButtons.slideDown();
				}
			}
		});

		$btn.on('click.tabs', (e) => {
			const id = $(e.currentTarget).data('id');
			const $curContent = $content.filter(`[data-id="${id}"]`);

			$btn.removeClass('is-active');
			$(e.currentTarget).addClass('is-active');
			$content.removeClass('is-active').addClass('is-hidden');
			$curContent.removeClass('is-hidden').addClass('is-active');

			if (helpers.isMobile()) {
				helpers.scrollTo($curContent, 500, -$btn.height() * 3 - 40);
				$btnActive.find('span').text($(e.currentTarget).text());
				$btnActive.trigger('click');
			} else {
				helpers.scrollTo($curContent, 500, -$btn.height() - 30);
			}
		});
	});
}

function destroy() {
	$('.js-tabs-btn').off('.tabs');
}

export default {
	init,
	destroy,
};
